export const SEARCH_CARE_PLAN_TEAM = "app/CarePlanTeam/SEARCH_CARE_PLAN_TEAM";
export const SEARCH_CARE_PLAN_TEAM_SUCCESS =
  "app/CarePlanTeam/SEARCH_CARE_PLAN_TEAM_SUCCESS";
export const SEARCH_CARE_PLAN_TEAM_FAILURE =
  "app/CarePlanTeam/SEARCH_CARE_PLAN_TEAM_FAILURE";

export const FETCH_CARE_PLAN_TEAM = "app/CarePlanTeam/FETCH_CARE_PLAN_TEAM";
export const FETCH_CARE_PLAN_TEAM_SUCCESS =
  "app/CarePlanTeam/FETCH_CARE_PLAN_TEAM_SUCCESS";
export const FETCH_CARE_PLAN_TEAM_FAILURE =
  "app/CarePlanTeam/FETCH_CARE_PLAN_TEAM_FAILURE";

export const ADD_CARE_PLAN_TEAM = "app/CarePlanTeam/ADD_CARE_PLAN_TEAM";
export const ADD_CARE_PLAN_TEAM_SUCCESS =
  "app/CarePlanTeam/ADD_CARE_PLAN_TEAM_SUCCESS";
export const ADD_CARE_PLAN_TEAM_FAILURE =
  "app/CarePlanTeam/ADD_CARE_PLAN_TEAM_FAILURE";

export const FETCH_CARE_PLAN_TEAM_MEMBER =
  "app/CarePlanTeam/FETCH_CARE_PLAN_TEAM_MEMBER";
export const FETCH_CARE_PLAN_TEAM_MEMBER_SUCCESS =
  "app/CarePlanTeam/FETCH_CARE_PLAN_TEAM_MEMBER_SUCCESS";
export const FETCH_CARE_PLAN_TEAM_MEMBER_FAILURE =
  "app/CarePlanTeam/FETCH_CARE_PLAN_TEAM_MEMBER_FAILURE";

export const EDIT_CARE_PLAN_TEAM = "app/CarePlanTeam/EDIT_CARE_PLAN_TEAM";
export const EDIT_CARE_PLAN_TEAM_SUCCESS =
  "app/CarePlanTeam/EDIT_CARE_PLAN_TEAM_SUCCESS";
export const EDIT_CARE_PLAN_TEAM_FAILURE =
  "app/CarePlanTeam/EDIT_CARE_PLAN_TEAM_FAILURE";

export const DELETE_CARE_PLAN_TEAM = "app/CarePlanTeam/DELETE_CARE_PLAN_TEAM";
export const DELETE_CARE_PLAN_TEAM_SUCCESS =
  "app/CarePlanTeam/DELETE_CARE_PLAN_TEAM_SUCCESS";
export const DELETE_CARE_PLAN_TEAM_FAILURE =
  "app/CarePlanTeam/DELETE_CARE_PLAN_TEAM_FAILURE";

export const SET_CARE_PLAN_TEAM_ADD_EDIT_MODAL =
  "app/CarePlanTeam/SET_CARE_PLAN_TEAM_ADD_EDIT_MODAL";
